import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "trigger", "spinner"]
  static values = {
    url: String,
    lang: String,
    loading: { type: Boolean, default: false }
  }

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      { rootMargin: "200px" }
    )

    if (this.hasTriggerTarget) {
      this.observer.observe(this.triggerTarget)
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersection(entries) {
    const entry = entries[0]
    if (entry.isIntersecting && !this.loadingValue) {
      this.loadMore()
    }
  }

  retry() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.innerHTML = ""
    }
    this.loadMore()
  }

  async loadMore() {
    if (this.loadingValue || !this.hasTriggerTarget) return

    this.loadingValue = true
    const cursor = this.triggerTarget.dataset.cursor

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("cursor", cursor)
      if (this.langValue) {
        url.searchParams.set("lang", this.langValue)
      }

      const response = await fetch(url, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Failed to load")

      const html = await response.text()

      // Remove old trigger before adding new content
      this.observer.unobserve(this.triggerTarget)
      this.triggerTarget.remove()

      // Insert new content
      this.containerTarget.insertAdjacentHTML("beforeend", html)

      // Observe new trigger if it exists
      if (this.hasTriggerTarget) {
        this.observer.observe(this.triggerTarget)
      }
    } catch (error) {
      console.error("Infinite scroll error:", error)
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.innerHTML = `<button class="btn btn-sm" data-action="infinite-scroll#retry">Failed to load — Retry</button>`
      }
    } finally {
      this.loadingValue = false
    }
  }
}
